import {
  STORE_IMMUTABLE_MENU_LIST,
  UPDATE_IMMUTABLE_MENU_ITEM_LIKE,
  UPDATE_IMMUTABLE_MENU_ITEM_FAVORITE
} from "../actions";

export default function immutableMenuList(state = {}, action) {
  const { foodId, like, favorite } = action.payload || {};
  let item;

  if (foodId) {
    item = state[foodId];
  }

  // let extrasItems = {};
  // if (cartItems && Object.keys(cartItems).length !== 0) {
  //   if (state && Object.keys(state).length !== 0) {
  //     let cartItemIds = Object.keys(cartItems);
  //     cartItemIds.map(item => {
  //       let properFoodId = item.split("~")[0];
  //       extrasItems[properFoodId] = state[properFoodId];
  //     });
  //   }
  // }

  switch (action.type) {
    case STORE_IMMUTABLE_MENU_LIST:
      return action.payload;
    case UPDATE_IMMUTABLE_MENU_ITEM_LIKE:
      item.like = like;
      state[foodId] = { ...item };
      return { ...state };
    case UPDATE_IMMUTABLE_MENU_ITEM_FAVORITE:
      item.favorite = favorite;
      state[foodId] = { ...item };
      return { ...state };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/immutableMenuList.js